(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  // Keep Seel's label click path; its hidden checkbox must remain untouched.
  const mdProtectionDrawer = document.getElementById('CartDrawer');
  if (mdProtectionDrawer) {
    mdProtectionDrawer.addEventListener('click', (event) => {
      if (event.target.closest('.md-cart-header .drawer__close') && typeof mdProtectionDrawer.hide === 'function') {
        event.preventDefault();
        event.stopImmediatePropagation();
        mdProtectionDrawer.hide();
      }
    }, true);
    const mdProtectionLabels = new WeakSet();
    const mdProtectionMobile = window.matchMedia('(max-width: 749px)');
    const nameProtectionControls = () => {
      mdProtectionDrawer.querySelectorAll('.seal-widget').forEach((widget) => {
        const content = widget.querySelector('.seal-widget-right');
        const existingDetails = widget.querySelector('.md-protection-details');
        if (mdProtectionMobile.matches && content && !existingDetails && !widget.querySelector('.seal-collapse-toggle')) {
          const details = document.createElement('details');
          details.className = 'md-protection-details';
          const summary = document.createElement('summary');
          summary.textContent = mdProtectionDrawer.dataset.protectionDetailsLabel;
          content.before(details);
          details.append(summary, content);
        } else if (!mdProtectionMobile.matches && existingDetails && content) {
          existingDetails.before(content);
          existingDetails.remove();
        }
        const input = widget.querySelector('input[data-seel-wfp-input]');
        const label = widget.querySelector('label.seal_widget--toggle');
        const name = widget.querySelector('[data-seel-wfp-name]')?.textContent.trim();
        if (input && label && name) {
          label.setAttribute('role', 'switch');
          label.setAttribute('tabindex', input.disabled ? '-1' : '0');
          label.setAttribute('aria-label', name);
          label.setAttribute('aria-checked', String(input.checked));
          label.setAttribute('aria-disabled', String(input.disabled));
          if (!mdProtectionLabels.has(label)) {
            mdProtectionLabels.add(label);
            label.addEventListener('keydown', (event) => {
              if ((event.key === ' ' || event.key === 'Enter') && !input.disabled) {
                event.preventDefault();
                label.click();
              }
            });
          }
        }
      });
    };
    nameProtectionControls();
    mdProtectionMobile.addEventListener('change', nameProtectionControls);
    mdProtectionDrawer.addEventListener('click', () => {
      requestAnimationFrame(nameProtectionControls);
    }, true);
    mdProtectionDrawer.addEventListener('change', () => {
      requestAnimationFrame(nameProtectionControls);
    }, true);
    new MutationObserver(nameProtectionControls).observe(mdProtectionDrawer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'checked']
    });
  }

  } catch(e) { console.error(e); }
})();
})();
